import React, { useEffect, useState } from "react";
const moment = require("moment");
import { useDispatch } from "react-redux";
import { useDialog } from "../../../../contexts/DialogContext";
import SaveIcon from "@mui/icons-material/Save";
import { showSuccessSnackbar, showErrorSnackbar } from "../../../../redux/slices/snackbar";
import {
  Grid,
  Divider as MuiDivider,
  Box,
  DialogActions,
  Button,
  CircularProgress,
  Typography as MuiTypography,
  Alert,
  Stack,
} from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import useUser from "../../../../hooks/useUser";

function RefreshPaymentStatus(props) {
  const { refreshPage, selectedRows, setSelectedRows } = props;
  const [paymentStatusResponse, setPaymentStatusResponse] = useState([]);

  const { syncPaymentStatus, isLoadingSyncPaymentStatus } = useUser();
  const dispatch = useDispatch();
  const { unSetDialog, openDialog } = useDialog();

  const methods = useForm();

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
  } = methods;

  const onSubmit = async (data) => {
    try {
      if (selectedRows == 0) {
        return dispatch(showErrorSnackbar("Please select at least one transaction"));
      }
      const response = await syncPaymentStatus(selectedRows);
      setPaymentStatusResponse(response);
      refreshPage();
      setSelectedRows([]);
    } catch (err) {
      dispatch(showErrorSnackbar(err.message));
    }
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} className="row" pt={8}>
            <Grid item md={6}>
              <i>Do you want to update payment status?</i>
            </Grid>
          </Grid>
          <DialogActions>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              endIcon={isLoadingSyncPaymentStatus ? <CircularProgress size={24} /> : null}
              disabled={isLoadingSyncPaymentStatus}
            >
              Update
            </Button>
          </DialogActions>
        </form>
        <Stack spacing={1}>
          {paymentStatusResponse.map((item, index) => (
            <Alert key={index} severity={item.status ? "success" : "error"}>
              {item.message + ", Order Id: " + item.orderId}
            </Alert>
          ))}
        </Stack>
      </FormProvider>
    </React.Fragment>
  );
}

export default RefreshPaymentStatus;
